const madeTeaTypeList = [
  {
    value: 1,
    text: 'C T C',
    text_en: 'C T C',
    text_bn: 'সি টি সি'
  },
  {
    value: 2,
    text: 'Green Tea',
    text_en: 'Green Tea',
    text_bn: 'সবুজ চা'
  },
  {
    value: 3,
    text: 'Orthodox Tea',
    text_en: 'Orthodox Tea',
    text_bn: 'অর্থডক্স চা'
  },
  {
    value: 4,
    text: 'Yellow Tea',
    text_en: 'Yellow Tea',
    text_bn: 'হলুদ চা'
  },
  {
    value: 5,
    text: 'White Tea',
    text_en: 'White Tea',
    text_bn: 'সাদা চা'
  },
  {
    value: 6,
    text: 'Other Tea',
    text_en: 'Other Tea',
    text_bn: 'অন্যান্য চা'
  }
]
const inspectByList = [
  {
    value: 1,
    text: 'Executive Magistrate',
    text_en: 'Executive Magistrate',
    text_bn: 'নির্বাহী ম্যাজিস্ট্রেট'
  },
  {
    value: 2,
    text: 'DNCRP Representative',
    text_en: 'DNCRP Representative',
    text_bn: 'ডিএনসিআরপি প্রতিনিধি'
  }
]
const zoneList = [
  {
    value: 1,
    text: 'Chattogram',
    text_en: 'Chattogram',
    text_bn: 'চট্টগ্রাম'
  },
  {
    value: 2,
    text: 'Sreemangal',
    text_en: 'Sreemangal',
    text_bn: 'শ্রীমঙ্গল'
  },
  {
    value: 3,
    text: 'Panchagarh',
    text_en: 'Panchagarh',
    text_bn: 'পঞ্চগড়'
  }
]
const frequencyTypeList = [
  {
    value: 1,
    text: 'Daily',
    text_en: 'Daily',
    text_bn: 'দৈনিক'
  },
  {
    value: 2,
    text: 'Weekly',
    text_en: 'Weekly',
    text_bn: 'সাপ্তাহিক'
  },
  {
    value: 3,
    text: 'Monthly',
    text_en: 'Monthly',
    text_bn: 'মাসিক'
  },
  {
    value: 4,
    text: 'Yearly',
    text_en: 'Yearly',
    text_bn: 'বার্ষিক'
  }
]
function generateYearList () {
  const min = new Date().getFullYear()
  const oldMax = min - 50
  const newMax = min
  const newYears = []
  const oldYears = []
  for (let i = oldMax; i < min; i++) {
      oldYears.push(i)
  }
  for (let j = min; j <= newMax; j++) {
      newYears.push(j)
  }
  const yearList = [...oldYears, ...newYears]
  return yearList
}
const yearList = generateYearList()
// year list for scholarship & season amount distribution
function generateSeasonYearList () {
  const min = new Date().getFullYear()
  const oldMax = min - 2
  const newMax = min + 2
  const newYears = []
  const oldYears = []
  for (let i = oldMax; i < min; i++) {
      oldYears.push(i)
  }
  for (let j = min; j <= newMax; j++) {
      newYears.push(j)
  }
  const yearList = [...oldYears, ...newYears]
  return yearList
}
const seasonYearList = generateSeasonYearList()
const trustType = [
  {
    value: 1,
    text: 'Primary',
    text_en: 'Primary',
    text_bn: 'প্রাথমিক'
  },
  {
    value: 2,
    text: 'Secondary',
    text_en: 'Secondary',
    text_bn: 'মাধ্যমিক'
  }
]
const gardenType = [
  {
    value: 1,
    text: 'Tea Estate',
    text_en: 'Tea Estate',
    text_bn: 'চা এস্টেট'
  },
  {
    value: 2,
    text: 'Tea Garden',
    text_en: 'Tea Garden',
    text_bn: 'চা বাগান'
  },
  {
    value: 3,
    text: 'Small Tea Garden',
    text_en: 'Small Tea Garden',
    text_bn: 'ছোট চা বাগান'
  }
]
const workerType = [
  {
    value: 1,
    text: 'Registered',
    text_en: 'Registered',
    text_bn: 'নিবন্ধিত'
  },
  {
    value: 2,
    text: 'Unregistered',
    text_en: 'Unregistered',
    text_bn: 'অনিবন্ধিত'
  }
]
const gender = [
  {
    value: 1,
    text: 'Male',
    text_en: 'Male',
    text_bn: 'পুরুষ'
  },
  {
    value: 2,
    text: 'Female',
    text_en: 'Female',
    text_bn: 'মহিলা'
  },
  {
    value: 3,
    text: 'Other',
    text_en: 'Other',
    text_bn: 'অন্যান্য'
  }
]
const schoolLocation = [
  {
    value: 1,
    text: 'Inside Garden',
    text_en: 'Inside Garden',
    text_bn: 'বাগানের ভিতরে'
  },
  {
    value: 2,
    text: 'Outside (within 1 KM)',
    text_en: 'Outside (within 1 KM)',
    text_bn: 'বাহিরে (১ কি.মি. এর মধ্যে)'
  }
]
const schoolStatus = [
  {
    value: 1,
    text: 'Raw',
    text_en: 'Raw',
    text_bn: 'কাঁচা'
  },
  {
    value: 2,
    text: 'Semi Building',
    text_en: 'Semi Building',
    text_bn: 'সেমি বিল্ডিং'
  },
  {
    value: 3,
    text: 'Building',
    text_en: 'Building',
    text_bn: 'বিল্ডিং'
  }
]
const schoolCategory = [
  {
    value: 1,
    text: 'Government',
    text_en: 'Government',
    text_bn: 'সরকারী'
  },
  {
    value: 2,
    text: 'NGO',
    text_en: 'NGO',
    text_bn: 'এনজিও'
  },
  {
    value: 3,
    text: 'MPO/ Registered',
    text_en: 'MPO/ Registered',
    text_bn: 'এমপিও/ নিবন্ধিত'
  },
  {
    value: 4,
    text: 'Garden',
    text_en: 'Garden',
    text_bn: 'বাগান'
  }
]
const forestResource = [
  {
    value: 1,
    text: 'Shed Tree',
    text_en: 'Shed Tree',
    text_bn: 'শেড গাছ'
  },
  {
    value: 2,
    text: 'Planted Tree',
    text_en: 'Planted Tree',
    text_bn: 'লাগানো গাছ'
  },
  {
    value: 3,
    text: 'Natural Tree',
    text_en: 'Natural Tree',
    text_bn: 'প্রাকৃতিক গাছ'
  },
  {
    value: 4,
    text: 'Rubber',
    text_en: 'Rubber',
    text_bn: 'রাবার'
  },
  {
    value: 5,
    text: 'Bamboo',
    text_en: 'Bamboo',
    text_bn: 'বাঁশ'
  },
  {
    value: 6,
    text: 'Others',
    text_en: 'Others',
    text_bn: 'অন্যান্য'
  }
]
const purposeTreeFelling = [
  {
    value: 1,
    text: 'Tea Cultivation Extension',
    text_en: 'Tea Cultivation Extension',
    text_bn: 'চা চাষ সম্প্রসারণ'
  },
  {
    value: 2,
    text: 'Re-Plantation',
    text_en: 'Re-Plantation',
    text_bn: 'পুনরায় বৃক্ষরোপণ'
  },
  {
    value: 3,
    text: 'Very Old Tree',
    text_en: 'Very Old Tree',
    text_bn: 'খুব পুরানো গাছ'
  },
  {
    value: 4,
    text: 'Planted Rubber',
    text_en: 'Planted Rubber',
    text_bn: 'রোপণ করা রাবার'
  },
  {
    value: 5,
    text: 'Diseased Tree',
    text_en: 'Diseased Tree',
    text_bn: 'রোগাক্রান্ত গাছ'
  },
  {
    value: 6,
    text: 'Others',
    text_en: 'Others',
    text_bn: 'অন্যান্য'
  }
]
const unitQuantity = [
  {
    value: 1,
    text: 'Cubic Feet',
    text_en: 'Cubic Feet',
    text_bn: 'ঘনফুট'
  },
  {
    value: 2,
    text: 'Cubic Meter',
    text_en: 'Cubic Meter',
    text_bn: 'ঘন মিটার'
  }
]
const factoryApplicationApplicantType = [
  {
    value: 1,
    text: 'Individual',
    text_en: 'Individual',
    text_bn: 'ব্যাক্তি'
  },
  {
    value: 2,
    text: 'Limited Company',
    text_en: 'Limited Company',
    text_bn: 'লিমিটেড কোম্পানি'
  },
  {
    value: 3,
    text: 'Partnership Business',
    text_en: 'Partnership Business',
    text_bn: 'অংশীদারি কারবার'
  },
  {
    value: 4,
    text: 'Cooperative Institute',
    text_en: 'Cooperative Institute',
    text_bn: 'সমবায় প্রতিষ্ঠান'
  }
]
const organicFertilizerTypes = [
  {
    value: 1,
    text: 'Manure/organic manure',
    text_en: 'Manure/organic manure',
    text_bn: 'সার/জৈব সার'
  },
  {
    value: 2,
    text: 'Compost',
    text_en: 'Compost',
    text_bn: 'কম্পোস্ট'
  },
  {
    value: 3,
    text: 'Vermicompost',
    text_en: 'Vermicompost',
    text_bn: 'ভার্মিকম্পোস্ট'
  },
  {
    value: 4,
    text: 'Tricho Compost',
    text_en: 'Tricho Compost',
    text_bn: 'ট্রাইকো কম্পোস্ট'
  }
]
const soilTestType = [
  {
    value: 1,
    text: 'Garden Demand',
    text_en: 'Garden Demand',
    text_bn: 'বাগানের চাহিদা'
  },
  {
    value: 2,
    text: 'Advisory Test',
    text_en: 'Advisory Test',
    text_bn: 'পরামর্শমূলক প্রতিবেদন'
  }
]
const btriPaymentType = [
  {
    value: 1,
    text: 'Cash',
    text_en: 'Cash',
    text_bn: 'ক্যাশ'
  },
  {
    value: 2,
    text: 'Bank',
    text_en: 'Bank',
    text_bn: 'ব্যাংক'
  },
  {
    value: 3,
    text: 'Online',
    text_en: 'Online',
    text_bn: 'অনলাইন'
  }
]
const teaSmapleTestType = [
  {
    value: 1,
    text: 'Organoleptic',
    text_en: 'Organoleptic',
    text_bn: 'অর্গানলেপটিক'
  },
  {
    value: 2,
    text: 'Lab Test',
    text_en: 'Lab Test',
    text_bn: 'ল্যাব টেস্ট'
  }
]
const serviceAuthority = [
  {
    value: 1,
    text: 'BTB',
    text_en: 'BTB',
    text_bn: 'বিটিবি'
  },
  {
    value: 2,
    text: 'BTRI',
    text_en: 'BTRI',
    text_bn: 'বিটিআরআই'
  },
  {
    value: 3,
    text: 'PDU',
    text_en: 'PDU',
    text_bn: 'পিডিইউ'
  }
]
const unitList = [
  {
    value: 1,
    text: 'KG',
    text_en: 'KG',
    text_bn: 'কেজি'
  },
  {
    value: 2,
    text: 'PCs',
    text_en: 'PCs',
    text_bn: 'টি'
  },
  {
    value: 3,
    text: 'Meter',
    text_en: 'Meter',
    text_bn: 'মিটার'
  },
  {
    value: 4,
    text: 'Sotok',
    text_en: 'Sotok',
    text_bn: 'শতাংশ'
  }
]
const employeeType = [
  {
    value: 1,
    text: 'Management/ Officer',
    text_en: 'Management/ Officer',
    text_bn: 'ব্যবস্থাপনা/ কর্মকর্তা'
  },
  {
    value: 2,
    text: 'Weekly Laborer',
    text_en: 'Weekly Laborer',
    text_bn: 'সাপ্তাহিক শ্রমিক'
  },
  {
    value: 3,
    text: 'Staff',
    text_en: 'Staff',
    text_bn: 'কর্মচারী'
  },
  {
    value: 4,
    text: 'Monthly Laborer',
    text_en: 'Monthly Laborer',
    text_bn: 'মাসিক শ্রমিক'
  }
]
const headAccountType = [
  {
    value: 1,
    text: 'Add',
    text_en: 'Add',
    text_bn: 'যোগ'
  },
  {
    value: 2,
    text: 'Deduct',
    text_en: 'Deduct',
    text_bn: 'বাদ'
  }
]
const salesCenterNameList = [
  {
    value: 1,
    text: 'BADC',
    text_en: 'BADC',
    text_bn: 'বিএডিসি'
  },
  {
    value: 2,
    text: 'BCIC',
    text_en: 'BCIC',
    text_bn: 'বিসিআইসি'
  }
]
const applicationPhaseList = [
  {
    value: 1,
    text: 'In the first phase',
    text_en: 'In the first phase',
    text_bn: 'প্রথম দফায় '
  },
  {
    value: 2,
    text: 'In the second phase',
    text_en: 'In the second phase',
    text_bn: 'দ্বিতীয় দফায়'
  },
  {
    value: 3,
    text: 'In the third phase',
    text_en: 'In the third phase',
    text_bn: 'তৃতীয় দফায়'
  },
  {
    value: 4,
    text: 'In the four phase',
    text_en: 'In the four phase',
    text_bn: 'চতুর্থ দফায়'
  },
  {
    value: 5,
    text: 'In the five phase',
    text_en: 'In the five phase',
    text_bn: 'পঞ্চম দফায়'
  },
  {
    value: 6,
    text: 'In the six phase',
    text_en: 'In the six phase',
    text_bn: '৬ষ্ঠ দফায়'
  },
  {
    value: 7,
    text: 'In the seven phase',
    text_en: 'In the seven phase',
    text_bn: 'সপ্তম দফায়'
  }
]

const employeeList = [
  {
    value: 1,
    text: 'Manager, Asstt. Manager & Other Admin, Officer',
    text_en: 'Manager, Assit. Manager & Other Admin, Officer',
    text_bn: 'ম্যানেজার, সহকারী ম্যানেজার ও অন্যান্য প্রশাসনিক অফিসার'
  },
  {
    value: 2,
    text: 'Technical Officers, Engineers, Doctors etc.',
    text_en: 'Technical Officers, Engineers, Doctors etc.',
    text_bn: 'কারিগরি অফিসার, ইঞ্জিনিয়ার, ডাক্তার ইত্যাদি'
  },
  {
    value: 3,
    text: 'Admin Asstt. Clerks, Teachers, Babus etc',
    text_en: 'Admin Asstt, Clerks, Teachers, Babus etc',
    text_bn: 'প্রশাসনিক সহকারী, কেরানী, শিক্ষক, বাবু ইত্যাদি'
  },
  {
    value: 4,
    text: 'Technical Asstt, Carpenters, Plumbers etc.',
    text_en: 'Technical Asstt, Carpenters, Plumbers etc.',
    text_bn: 'কারিগরি সহকারী, সুতার মিস্ত্রী ইত্যাদি'
  },
  {
    value: 5,
    text: 'Peon, Darwans, Drivers etc.',
    text_en: 'Peon, Darwans, Drivers etc.',
    text_bn: 'পিয়ন, দারোয়ান, ড্রাইভার ইত্যাদি'
  }
]

const labourerList = [
  {
    value: 1,
    text: 'Adult Man',
    text_en: 'Adult Man',
    text_bn: 'বয়স্ক পুরুষ'
  },
  {
    value: 2,
    text: 'Adult Women',
    text_en: 'Adult Women',
    text_bn: 'বয়স্ক মহিলা'
  },
  {
    value: 3,
    text: 'Adolescent',
    text_en: 'Adolescent',
    text_bn: 'কিশোর'
  },
  {
    value: 4,
    text: 'Children',
    text_en: 'Children',
    text_bn: 'শিশু'
  }
]

const staffTypeList = [
  {
    value: 1,
    text: 'Employee',
    text_en: 'Employee',
    text_bn: 'কর্মচারী'
  },
  {
    value: 2,
    text: 'Labourer',
    text_en: 'Labourer',
    text_bn: 'শ্রমিক'
  }
]

const returnTypeList = [
  {
    value: 1,
    text: 'Garden',
    text_en: 'Garden',
    text_bn: 'বাগান'
  },
  {
    value: 2,
    text: 'Factory',
    text_en: 'Factory',
    text_bn: 'কারখানা'
  }
]

const garrdenFactoryTypeList = [
  {
    value: 1,
    text: 'Garden',
    text_en: 'Garden',
    text_bn: 'বাগান'
  },
  {
    value: 2,
    text: 'Garden Factory',
    text_en: 'Garden Factory',
    text_bn: 'বাগানের কারখানা'
  },
  {
    value: 3,
    text: 'Bought Leaf Factory',
    text_en: 'Bought Leaf Factory',
    text_bn: 'বটলীফ কারখানা'
  }
]
const remarksType = [
  {
    value: 1,
    text: 'BTB',
    text_en: 'BTB',
    text_bn: 'বিটিবি'
  },
  {
    value: 2,
    text: 'BTRI',
    text_en: 'BTRI',
    text_bn: 'বিটিআরআই'
  },
  {
    value: 3,
    text: 'PDU',
    text_en: 'PDU',
    text_bn: 'পিডিইউ'
  },
  {
    value: 4,
    text: 'Garden',
    text_en: 'Garden',
    text_bn: 'বাগান'
  }
]
export default {
  madeTeaTypeList,
  inspectByList,
  frequencyTypeList,
  trustType,
  yearList,
  zoneList,
  gardenType,
  workerType,
  gender,
  schoolLocation,
  schoolStatus,
  schoolCategory,
  seasonYearList,
  forestResource,
  purposeTreeFelling,
  unitQuantity,
  factoryApplicationApplicantType,
  organicFertilizerTypes,
  soilTestType,
  btriPaymentType,
  teaSmapleTestType,
  serviceAuthority,
  unitList,
  employeeType,
  headAccountType,
  salesCenterNameList,
  applicationPhaseList,
  employeeList,
  labourerList,
  staffTypeList,
  returnTypeList,
  garrdenFactoryTypeList,
  remarksType
}
